// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"f1d06870","205":"6757d0ce","317":"cb571b35","348":"87d6d62e","472":"9e3c85d5","698":"b3abe254","905":"51285988","977":"8aad64d0"}[chunkId] + ".chunk.js";
};